export default __webpack_public_path__ + "files/media/plane-mobile.316f4c00.jpg";